import { render, staticRenderFns } from "./MoreMembers.vue?vue&type=template&id=513e347c&"
import script from "./MoreMembers.vue?vue&type=script&lang=js&"
export * from "./MoreMembers.vue?vue&type=script&lang=js&"
import style0 from "./MoreMembers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports